import { TitleSection } from "../title-section";
import PieChart from "./pie-chart";

export const Taxonomia = () => {
  return (
    <section id="taxonomia" className="py-10 px-4 lg:px-0 flex justify-center">
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <TitleSection blueToRed={false} first_title="Taxonomia da prova" />
        <div className="space-y-6">
          <div className="text-center">
            <div className="flex flex-col md:flex-row items-center justify-between w-full space-y-6 md:space-y-0 md:space-x-10">
              <PieChart />

              <div className="md:w-1/2">
                <div className="text-left">
                  <h2 className="text-xl md:text-2xl text-blue-500 font-semibold leading-tight">
                    O Impacto dos Verbos na Dificuldade
                  </h2>
                  <p className="text-gray-600 text-sm md:text-base mt-4">
                    No ENEM, a prova é construída em cima de uma Taxonomia de
                    Bloom Revisada para possibilitar a aplicação da TRI. Verbos
                    como "mostrar" e "apresentar" indicam perguntas mais
                    simples, enquanto "utilizar" e "avaliar" exigem processos
                    cognitivos mais profundos. Compreender os verbos envolvidos
                    nos itens da prova ajudam a entender a dificuldade da mesma
                    e a preparar-se melhor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
